import React from 'react';
import { AppLegalDoc, LegalIntro, LegalSection, LegalP, LegalLink } from '../components/AppLegalDoc';

function AppTermsPage() {
  return (
    <AppLegalDoc
      docTitle="Turf Umpire: Terms of use"
      updated="23 October 2026"
      seoTitle="Turf Umpire — Terms of use"
      seoDescription="Terms of use for Turf Umpire, the cricket scoring and umpiring app by Web Int Projects for Malda Cricket & Football Turf."
      seoPath="/app/terms-of-use"
      testId="app-terms-page"
    >
      <LegalIntro>
        These terms cover your use of Turf Umpire, made by Web Int Projects, for Malda Cricket &amp; Football Turf.
        By using the app you agree to them.
      </LegalIntro>

      <LegalSection title="Using the app">
        <LegalP>The app is free to use for scoring and umpiring your matches.</LegalP>
      </LegalSection>

      <LegalSection title="Scores">
        <LegalP>
          The app works out totals from the balls you enter, so the scorecard is only as right as what was tapped.
          Check it before you share it or use it to decide a tournament result.
        </LegalP>
      </LegalSection>

      <LegalSection title="Laws and signals">
        <LegalP>
          The laws section is a short guide in our own words, not the official Laws of Cricket from the MCC. Turf and
          gully games often play their own house rules. In a dispute, the rules agreed before the match and the
          umpire's call on the field come first.
        </LegalP>
      </LegalSection>

      <LegalSection title="Your matches">
        <LegalP>
          Matches are kept only on your phone. If you lose or reset the phone, or uninstall the app, they are gone, so
          share any scorecard you want to keep. The privacy policy has the details.
        </LegalP>
      </LegalSection>

      <LegalSection title="No guarantee">
        <LegalP>
          We work to keep the app correct and working, but it is provided as it is, without a guarantee. We aren't
          responsible for losses caused by a wrong score, lost data or the app not working.
        </LegalP>
      </LegalSection>

      <LegalSection title="Changes">
        <LegalP>
          We may update the app and these terms. Using the app after an update means you accept the new terms. These
          terms are governed by the laws of India.
        </LegalP>
      </LegalSection>

      <LegalSection title="Contact">
        <LegalP>
          Questions: <LegalLink href="mailto:maldaturf@gmail.com">maldaturf@gmail.com</LegalLink>
        </LegalP>
      </LegalSection>
    </AppLegalDoc>
  );
}

export default AppTermsPage;
